module.exports = __webpack_public_path__ + "static/img/4.14addd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/eng/4.png
// module id = 1nal
// module chunks = 0